import { render, staticRenderFns } from "./WatchData.vue?vue&type=template&id=800eed38&scoped=true&"
import script from "./WatchData.vue?vue&type=script&lang=js&"
export * from "./WatchData.vue?vue&type=script&lang=js&"
import style0 from "./WatchData.vue?vue&type=style&index=0&id=800eed38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800eed38",
  null
  
)

export default component.exports